import SchoolBannerimage2 from '../../../Images/Courses-banner.jpg';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import RecordCourseCard from './RecordCourseCard/RecordCourseCard';

const School = () => {
  return (
    <div>
      <Breadcrumb
        title='Our All Courses '
        subTitle='Courses'
        slgs='/courses'
        img={SchoolBannerimage2}
      ></Breadcrumb>
      <RecordCourseCard></RecordCourseCard>
    </div>
  );
};

export default School;
